exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{width:100%;height:100%;display:block}.table-container{display:flex;flex-direction:column;max-height:100%}.table-header{min-height:64px;max-width:500px;display:flex;align-items:baseline;padding:8px 24px 0;font-size:20px;justify-content:space-between}.mat-input-container{font-size:14px;flex-grow:1;margin-left:32px}.mat-table{overflow:auto}.mat-header-row,.mat-row{height:60px}.mat-cell-text{overflow:hidden;word-wrap:break-word}button{margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/shared/table/table.component.styl
// module id = 873
// module chunks = 0